import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/Common/input.scss'
const InputForm = ({
  value,
  title,
  onChange,
  placeholder,
  id,
  disabled,
  onBlur
}) => {
  
  return (
    <div className="form-group">
      <label>{title}</label>
      <input
        type="text"
        className="form-control"
        value={value}
        id={id}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => onChange(id, e.target.value)}
      />
    </div> 
  );
};

InputForm.propTypes = {
  value: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

InputForm.defaultProps = {
  disabled: false,
}

export default InputForm;
